export default {
  "templates.popoverProfile.myAccount": {
    en: "My account",
    es: "Mi cuenta",
  },
  "templates.popoverProfile.logout": {
    en: "Logout",
    es: "Cerrar sesión",
  },
  "templates.router.notFound.title": {
    en: "Oops",
    es: "Ups",
  },
  "templates.router.notFound.text": {
    en: "This page could be not found",
    es: "Esta página no existe",
  },
  "templates.typeahead.pricingTableTariffs.containsCosts": {
    en: "This rate has related costs",
    es: "Esta tarifa tiene costes asociados",
  },
};
